import { CommonModule } from '@angular/common';
import { Component, Input,  OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule,  } from '@angular/material/input';
import { KeyVal } from '@app/models/common';
import { MatAutocompleteModule} from '@angular/material/autocomplete';

import { Observable, startWith, map } from 'rxjs';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'so-auto-complete',
  templateUrl: './so-auto-complete.component.html',
  styleUrls: ['./so-auto-complete.component.css'],
  standalone: true,
  imports: [ 
    CommonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,    
    MatTooltipModule,
    MatAutocompleteModule,
    ReactiveFormsModule
  ]
})


export class SoAutoCompleteComponent implements OnInit{
  @Input() formCtrl: FormControl;
  @Input() placeHolder = "Please enter text.";
  @Input() disableClearBtn= false;
  @Input() errormessage = "Entry is invalid."
  @Input() label= "Label Not set."
  @Input() options:  KeyVal[] = []; 
  @Input() toolTip = "";

  filteredOptions: Observable<KeyVal[]>;


  ngOnInit() {
    this.filteredOptions = this.formCtrl.valueChanges
    .pipe(
      startWith(''),
      map((value : string)  => this.filter(value))
    );
  }

  filter(filterString: string): KeyVal[] {
    if (filterString === null) filterString = "";
    return this.options.filter(option =>
      option.value.toLowerCase().indexOf(filterString.toLowerCase()) === 0);
  }

  clearControl() {
    this.formCtrl.setValue(""); 
  }
 
}
